// Local translations
export const T = {
  en_GB: {
    displayOptions: "Display Options",
    displayDesc: "Choose how to display the asset allocation breakdown",
    showChart: "Show Chart",
    showChartDesc: "Display the pie chart visualization",
    showTable: "Show Table",
    showTableDesc: "Display data table with color indicators",
    atLeastOneOption: "At least one display option must be selected",
  },
  nb_NO: {
    displayOptions: "Visningsalternativer",
    displayDesc: "Velg hvordan aktivaallokeringen skal vises",
    showChart: "Vis diagram",
    showChartDesc: "Vis kakediagramvisualisering",
    showTable: "Vis tabell",
    showTableDesc: "Vis datatabell med fargeindikatorer",
    atLeastOneOption: "Minst ett visningsalternativ må velges",
  },
} as const;
